import { Component } from "react";
import Script from "next/script";

// import "./SearchBar.scss";
import { connect } from "react-redux";
import withTranslation from "next-translate/withTranslation";
import GetDataFromLatLng from "utils/CarteDesPrix/GetDataFromLatLng";
import PlacesAutocomplete from "utils/PlacesAutocomplete/PlacesAutocomplete";
import styles from "./SearchBar.module.css";
const isBrowser = () => typeof window !== "undefined";
import { cartePrixChangeDisplay, setPrix } from "redux/slices/carteprixReducer";
class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      coordinates: {
        lng: this.props.lng,
        lat: this.props.lat,
        script_loaded: true,
      },
      recentSearches:
        isBrowser() && window.localStorage.getItem("recentSearches")
          ? JSON.parse(window.localStorage.getItem("recentSearches"))
          : [],
      displayRecentSuggestions: false,
      recentSuggestions:
        isBrowser() && window.localStorage.getItem("recentSearches")
          ? JSON.parse(window.localStorage.getItem("recentSearches"))
          : [],
    };
  }

  postHandleSelect = (recherche) => {
    GetDataFromLatLng(recherche.lat, recherche.lng, recherche.niveau)
      .then((res) => {
        if (res.data[0]) {
          this.props.setPrix({
            data: res.data[0],
          });
        }
      })
      .catch((err) => { });

    if (window.cartedesprix) {
      window.cartedesprix.flyTo({
        center: [recherche.lng, recherche.lat],
        zoom: recherche.zoom,
        speed: recherche.speed,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { t } = this.props.i18n;
    return (
      <>


        <div className={`${styles.search__bar__container}`}>
          <div className={styles.search__bar__input__container}>
            <div>

              <PlacesAutocomplete
                enableDefaultSearchList={true}
                postHandleSelect={this.postHandleSelect}
                page=""
                placeholder=""
                t={t}
                showSearchIcon={true}
              />
            </div>
          </div>

          <div
            className={`${styles.map__btn__container} mapagenceSwap--button`}
          >
            <button
              className={styles.map__search__btn}
              onClick={() => {
                this.props.cartePrixChangeDisplay({
                  data: "",
                });
              }}
            >
              {
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.75 8.25H11.25M3.75 4.5H11.25M3.75 0.75H11.25M0.751465 8.25V8.2515L0.75 8.25146V8.25H0.751465ZM0.751465 4.5V4.5015L0.75 4.50146V4.5H0.751465ZM0.751465 0.75V0.7515L0.75 0.751465V0.75H0.751465Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              {this.props.todisplay === "CARTE" ? t("INFO") : t("CARTE")}
            </button>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    lat: state.carteprix.lat,
    lng: state.carteprix.lng,
    todisplay: state.carteprix.todisplay,
    zoomEndFromMarkerCDP: state.carteprix.zoomEndFromMarkerCDP,
  };
};
const mapDispatchToProps = {
  cartePrixChangeDisplay,
  setPrix,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(SearchBar, "prixImmobilierMaroc"));
